import { create } from 'zustand'

type AppActivityState = {
  active: boolean
  setActive: (active: boolean) => void
}

const useAppActivity = create<AppActivityState>((set) => ({
  active: true,
  setActive: (active) => {
    set({ active })
  },
}))

export const useAppActive = () => useAppActivity((state) => state.active)

export default useAppActivity
